import { createContext, useState } from 'react'

const AccessDataContext = createContext()

export function AccessDataProvider({ children }) {
  const [accessDataType, setAccessDataType] = useState([])

  const addDataToContext = (type) => {
    setAccessDataType((prevState) => [...prevState, type])
  }
  const deleteDataFromcCntext = (type) => {
    setAccessDataType((prevState) =>
      prevState.filter((value) => value !== type)
    )
  }
  return (
    <AccessDataContext.Provider
      value={{ accessDataType, addDataToContext, deleteDataFromcCntext }}
    >
      {children}
    </AccessDataContext.Provider>
  )
}

export default AccessDataContext
